import i18n from "@/i18n";
import vuetify from "@/plugins/vuetify";
import {getUserInfo, tokenUserInfo} from "@/lib/authentication";
import {getLanguage} from "@/lib/funclib";
import axios from "axios";
import router from "@/router";
let jwtDecode = require('jwt-decode');

export default {
    state: {
        jwt: localStorage.getItem('jwt'),
        lang: getLanguage(),
        userInfo: tokenUserInfo(localStorage.getItem('jwt')),
    },
    getters: {
        isAuthenticated: state => {
            return (state.jwt != null);
        },
        jwt: state => {
            return state.jwt;
        },
        lang: state => {
            return state.lang;
        },
        userInfo: state => {
            return state.userInfo;
        }
    },
    mutations: {
        updateToken(state, newToken) {
            if (newToken) {
                let tokenInfo = tokenUserInfo(newToken);
                if (tokenInfo.id !== 'None') {
                    localStorage.setItem('jwt', newToken);
                    state.jwt = newToken;
                    state.userInfo = tokenInfo;
                    // eslint-disable-next-line no-console
                    console.log(tokenInfo);
                    getUserInfo(state.userInfo.id);
                }
            }
        },
        removeToken(state) {
            localStorage.removeItem('jwt');
            state.jwt = null;
            state.userInfo = null;
        },
        setLanguage(state, lang) {
            localStorage.setItem('lang', lang);
            state.lang = lang;
            i18n.locale = lang;
            vuetify.rtl = (lang === 'ar');
        },
        updateUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
    },
    actions: {
        getUserInfo: context => {
            if (context.state.userInfo  != null && context.state.userInfo.id) {
                getUserInfo(context.state.userInfo.id);
            }
        },
        obtainToken (context, { username, password }) {
            const payload = {
                username: username,
                password: password
            };
            axios.post(
                this.state.endpoints.obtainJWT,
                payload,
                {
                    // headers: {
                    //   'Access-Control-Allow-Origin': '*',
                    //   'Access-Control-Allow-Headers': 'access-control-allow-origin'
                    // }
                }
            ).then((response) => {
                this.commit('updateToken', response.data.token);
                // eslint-disable-next-line no-console
                console.log('redirecting to home');
                router.push({ name: 'home' })
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log(error)
            })
        },
        refreshToken (state) {
            const payload = {
                token: state.jwt
            };
            axios.post(state.endpoints.refreshJWT, payload)
                .then((response) => {
                    this.commit('updateToken', response.data.token)
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },
        inspectToken (state) {
            const token = state.jwt;
            if (token) {
                const decoded = jwtDecode(token);
                const exp = decoded.exp;
                const origIat = decoded.orig_iat;
                if (exp - (Date.now() / 1000) < 1800 && (Date.now() / 1000) - origIat < 628200) {
                    this.dispatch('refreshToken')
                } else if (exp - (Date.now() / 1000) < 1800) {
                    // DO NOTHING, DO NOT REFRESH
                } else {
                    // PROMPT USER TO RE-LOGIN, THIS ELSE CLAUSE COVERS THE CONDITION WHERE A TOKEN IS EXPIRED AS WELL
                    state.removeToken()
                }
            }
        }
    },
};
